// 共享的服务数据与查询方法
import imgDeepClean from '../image/深度清洁.jfif';
import imgDailyClean from '../image/日常保洁.jpg';
import imgElderCare from '../image/老人护理.jfif';
import imgBabyCare from '../image/月嫂服务.webp';
import imgCooking from '../image/家庭烹饪.webp';
// 新增图片资源导入
import imgHood from '../image/油烟机清洗.webp';
import imgWasherFront from '../image/滚筒洗衣机清理.jpg';
import imgACClean from '../image/空调清洗家政.png';
import imgACCabinet from '../image/柜机空调拆洗.jpg';
import imgWindowOil from '../image/窗户油污清洗.webp';
import imgWasherTop from '../image/波轮洗衣机清洗.jpg';
import imgSewer from '../image/下水道疏通.webp';

export const services = [
  {
    id: 1,
    name: '深度清洁',
    category: 'cleaning',
    price: 128,
    duration: '3小时',
    description: '提供全方位的家庭深度清洁服务。服务范围包括但不限于厨房、卫生间、客厅、卧室的墙面、地面、家具家电表面、玻璃等。我们采用专业清洁工具和环保清洁剂，针对重油污、水垢、霉斑等顽固污渍进行重点处理，致力于恢复您家居环境的整洁与亮丽如新。',
    image: imgDeepClean,
    features: ['含全屋基础清洁', '厨房重油污处理', '卫生间消毒杀菌', '地面/墙面细节清洁'],
    includes: ['工具与清洁剂', '上门服务', '售后咨询'],
    notes: '建议提前预约并保持现场通风。'
  },
  {
    id: 2,
    name: '日常保洁',
    category: 'cleaning',
    price: 88,
    duration: '2小时',
    description: '为维持家庭日常整洁而设的定期保洁服务。服务流程包括地面清洁、家具擦拭、垃圾清理、物品整理归位等。此服务旨在通过定期维护，为您创造一个持续舒适、整洁的生活空间，减轻您的家务负担。',
    image: imgDailyClean,
    features: ['客厅/卧室清洁', '台面擦拭', '垃圾分类与清运', '简单物品收纳'],
    includes: ['基础工具', '上门服务'],
    notes: '适合周度或半月维护。'
  },
  {
    id: 3,
    name: '老人护理',
    category: 'care',
    price: 168,
    duration: '4小时',
    description: '提供专业、贴心的老人日常照料与陪伴服务。服务内容涵盖协助起居、饮食、个人卫生等生活照料，同时提供情感陪伴、安全看护及简单的康复活动辅助。我们的目标是确保老人在熟悉的环境中享受到安全、舒适、有尊严的晚年生活。',
    image: imgElderCare,
    features: ['日常起居照料', '简单康复训练', '情绪陪伴', '安全看护'],
    includes: ['护理人员上门', '基础健康观察'],
    notes: '如有特殊病史请提前告知。'
  },
  {
    id: 4,
    name: '月嫂服务',
    category: 'baby',
    price: 298,
    duration: '8小时',
    description: '为新生儿家庭提供科学、全面的母婴护理服务。服务包含新生儿的日常护理（喂养、洗澡、抚触）、健康状况观察，以及产妇的产后恢复指导、心理疏导和营养膳食建议。我们的专业月嫂将帮助您平稳度过产后关键期。',
    image: imgBabyCare,
    features: ['新生儿护理', '产后恢复指导', '科学喂养', '环境消毒'],
    includes: ['专业护理顾问', '个性化护理方案'],
    notes: '建议产前预约，匹配更合适的月嫂。'
  },
  {
    id: 5,
    name: '家庭烹饪',
    category: 'cooking',
    price: 98,
    duration: '2小时',
    description: '根据您的家庭口味与健康需求，提供上门烹饪服务。服务流程包括根据定制菜单进行食材的准备、烹饪处理，以及餐后厨房的基本清洁。无论是家常菜还是特定饮食要求，我们都能为您提供美味、健康的餐饮解决方案。',
    image: imgCooking,
    features: ['定制菜谱', '营养搭配', '食材处理与烹饪', '厨房卫生整理'],
    includes: ['厨师上门', '烹饪工具自备/可协商'],
    notes: '如需代购食材请提前说明。'
  },
  {
    id: 6,
    name: '油烟机清洗服务',
    category: 'appliance',
    price: 168,
    duration: '1.5小时',
    description: '专业拆解油烟机，使用高温蒸汽和环保清洗剂，深度清除内部风轮、涡轮、油网和机腔的顽固油垢。服务旨在恢复油烟机吸力，消除异味和火灾隐患，提升厨房空气质量。',
    image: imgHood,
    features: ['叶轮深度除油', '机腔除垢', '外壳抛光', '环保清洗剂'],
    includes: ['标准拆洗', '基本防护措施'],
    notes: '重度油污或商用设备需另行评估。'
  },
  {
    id: 7,
    name: '滚筒洗衣机清洗服务',
    category: 'appliance',
    price: 198,
    duration: '2小时',
    description: '通过专业工具拆卸洗衣机内筒，全面清洗内外筒壁、滚筒夹层、门封圈等卫生死角，有效去除长期积累的污垢、霉菌和异味，保障衣物洗涤健康，避免二次污染。',
    image: imgWasherFront,
    features: ['内外筒拆卸冲洗', '加热杀菌', '排水系统检查', '密封圈清理'],
    includes: ['专业工具', '环保除菌剂'],
    notes: '若机器生锈或老化部件需提前说明。'
  },
  {
    id: 8,
    name: '空调清洗服务',
    category: 'appliance',
    price: 158,
    duration: '1.5小时',
    description: '对挂式空调的过滤网、蒸发器、风轮等核心部件进行深度清洁和消毒，有效去除灰尘、细菌，改善出风质量，提升制冷/制热效率，同时降低能耗和运行噪音。',
    image: imgACClean,
    features: ['蒸发器冲洗', '过滤网杀菌清洗', '风轮除尘', '外机简单除尘'],
    includes: ['基础防护布', '环保清洗剂'],
    notes: '多台空调可打包优惠。'
  },
  {
    id: 9,
    name: '柜机空调拆洗服务',
    category: 'appliance',
    price: 238,
    duration: '2小时',
    description: '针对柜机空调进行全面拆解清洗，覆盖面板、风道、蒸发器、风轮电机等所有可清洗部件。服务旨在彻底解决因积尘导致的制冷效果差、异味、耗电量大等问题。',
    image: imgACCabinet,
    features: ['面板拆卸', '风道深度清洁', '蒸发器冲洗', '风轮/电机区域除尘'],
    includes: ['全套防护', '专业师傅'],
    notes: '高空或特殊安装环境需额外说明。'
  },
  {
    id: 10,
    name: '窗户油污清洗服务',
    category: 'cleaning',
    price: 128,
    duration: '1.5小时',
    description: '专项针对厨房等重油污区域的窗户进行清洁。使用专业除油剂，有效分解玻璃、窗框和窗槽上的油膜和污垢，恢复窗户的透光性，让视野更清晰明亮。',
    image: imgWindowOil,
    features: ['玻璃除油膜', '窗槽细节处理', '防雾处理', '安全作业'],
    includes: ['清洁剂与工具', '上门服务'],
    notes: '高层外窗需确认可安全操作。'
  },
  {
    id: 11,
    name: '波轮洗衣机清洗服务',
    category: 'appliance',
    price: 168,
    duration: '1.5小时',
    description: '拆解波轮洗衣机内桶，深度清洁桶壁、底盘及夹层中隐藏的水垢、洗衣粉残留和霉菌。服务旨在从根源上解决衣物洗不净、有异味的问题，守护家人健康。',
    image: imgWasherTop,
    features: ['桶底拆卸', '深层除垢', '杀菌除味', '排水系统检查'],
    includes: ['标准工具', '环保清洁剂'],
    notes: '老旧机器塑料件脆化可能影响拆卸进度。'
  },
  {
    id: 12,
    name: '下水道疏通',
    category: 'cleaning',
    price: 150,
    duration: '1小时',
    description: '采用专业疏通设备，快速解决厨房水槽、卫生间地漏、马桶等各类管道堵塞问题。服务流程安全高效，致力于迅速恢复管道通畅，避免对您日常生活造成影响。',
    image: imgSewer,
    features: ['专业疏通设备', '快速上门服务', '不通不收费', '管道损伤风险低'],
    includes: ['师傅上门费', '基础疏通服务'],
    notes: '如遇复杂堵塞或需要拆卸管道，可能产生额外费用。'
  }
];

export const getServiceById = (id) => {
  const numId = Number(id);
  return services.find(s => s.id === numId) || null;
};

